export default "__VITE_ASSET__BSCwUeXt__"